












































































































































































































































































































































































import { Component, Vue, Watch, Prop, Ref } from "vue-property-decorator";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import FormDescription from "@/components/misc/FormDescription.vue";
import * as _ from "lodash";
import NoData from "@/components/misc/NoData.vue";
import { AccomodationUnitViewModel } from "@/shared/models/accomodationUnitTypeViewModel";
import NumericInputImproved from "@/components/numbers/NumericInputImproved.vue";
import { Action, Getter } from "vuex-class";
import { OwnerPricingModel } from "@/shared/models/ownerPricingModel";
import PropertyOwner from "./PropertyOwner.vue";
import {
  AgencyWorkModel,
  AgencyWorkModelsEnum,
} from "@/shared/models/agencyWorkModel";
import { VATCategoryForPrepayments } from "@/shared/models/vatCategoryForPrepayments";
import DateField from "@/components/misc/DateField.vue";
import {
  EVisitorIntegrationNameEnum,
  OwnerContractExportType,
} from "@/shared/models/enums.type";
import { saveFile } from "@/shared/saveFile";
import { ListModel } from "@/shared/models/listModel";
import {
  EVisitorIntegrationModel,
  EVisitorView,
} from "@/shared/models/eVisitor";

@Component({
  components: {
    RightDrawer,
    FormDescription,
    NoData,
    NumericInputImproved,
    PropertyOwner,
    DateField,
  },
})
export default class AccomodationUnitForm extends Vue {
  @Prop({ default: null }) unit!: AccomodationUnitViewModel | null;
  @Prop({ default: false }) open!: boolean;
  @Prop() callback!: () => any;
  @Prop({ default: 0 }) propertyOwnerPricingModelId?: number | null;
  @Prop({ default: 0 }) propertyOwnerPayoutPercent?: number | null;
  @Prop() propertyId?: number;

  @Getter("appParams/tenantEVisitorIntegration")
  eVisitorIntegration?: EVisitorIntegrationModel;

  get eVisitorIntegrationName() {
    return this.eVisitorIntegration?.name ?? EVisitorIntegrationNameEnum.None;
  }

  @Action("codebooks/refreshOwnerPricingModels")
  refreshOwnerPricingModels?: () => Promise<void>;

  @Action("cashRegister/refreshCashRegisters")
  refreshCashRegisters?: () => Promise<void>;

  @Getter("codebooks/ownerPricingModels")
  ownerPricingModels?: OwnerPricingModel[];

  @Action("codebooks/refreshAgencyWorkModels")
  refreshAgencyWorkModels?: () => Promise<void>;
  @Getter("codebooks/agencyWorkModels") agencyWorkModels?: AgencyWorkModel[];
  agencyWorkModelsEnum = AgencyWorkModelsEnum;

  @Action("codebooks/refreshVATCategoriesForPrepayments")
  refreshVATCategoriesForPrepayments?: () => Promise<void>;
  @Getter("codebooks/vatCategoriesForPrepayments")
  vatCategoriesForPrepayments?: VATCategoryForPrepayments[];

  @Getter("appParams/showOwnerPriceOffset") showOwnerPriceOffset?: boolean;
  @Getter("appParams/typeId") tenantTypeId?: number;
  @Getter("appParams/tenantHasAgencyCommissionForPrepayments")
  tenantHasAgencyCommissionForPrepayments?: boolean;

  @Getter("appParams/tenantUsesInputPrice")
  tenantUsesInputPrice?: boolean;

  tab = 0;

  fkey = 0;

  loading = false;
  saving = false;
  generateOwnerContractOpen = false;
  ownerContractExportType = null;
  cityTaxItems = [
    {
      value: true,
      text: "Unit.PaysCityTax.True",
    },
    {
      value: false,
      text: "Unit.PaysCityTax.False",
    },
    {
      value: null,
      text: "Unit.PaysCityTax.ByProperty",
    },
  ];

  initialAccomodationUnit = new AccomodationUnitViewModel();
  accomodationUnit = new AccomodationUnitViewModel();

  async created() {
    const promises = [];

    if (
      (this.ownerPricingModels?.length ?? 0) === 0 &&
      this.refreshOwnerPricingModels
    ) {
      promises.push(this.refreshOwnerPricingModels());
    }
    if (
      (this.agencyWorkModels?.length ?? 0) === 0 &&
      this.refreshAgencyWorkModels
    ) {
      promises.push(this.refreshAgencyWorkModels());
    }
    if (
      (this.vatCategoriesForPrepayments?.length ?? 0) === 0 &&
      this.refreshVATCategoriesForPrepayments
    ) {
      promises.push(this.refreshVATCategoriesForPrepayments());
    }

    await Promise.all(promises);
  }

  @Watch("accomodationUnit.sortOrder")
  sortOrderWatch(fresh: number | string) {
    if (fresh === "") {
      this.accomodationUnit.sortOrder = null;
    }
  }

  @Watch("accomodationUnit.agencyWorkModelId")
  ownNameElseAccount(workModel: AgencyWorkModelsEnum | string)
  {
    if(workModel === this.agencyWorkModelsEnum.OwnNameAndOtherInvoice && this.vatCategoriesForPrepayments?.length === 1)
     {
      this.accomodationUnit.vatCategoryForPrepaymentsId = this.vatCategoriesForPrepayments[0].id
     }
  }

  @Watch("open")
  async openWatch(fresh: boolean, old: boolean) {
    if (fresh && !old) {
      this.fkey++;
      this.tab = 0;

      if (!this.evisitorFacilities || this.evisitorFacilities.length == 0)
        this.loadPropertyEVisitoryFacilities();
    }

    if (fresh && this.unit) {
      this.accomodationUnit = this.unit;
      if (this.accomodationUnit.ownerId == null) {
        this.accomodationUnit.ownerPriceOffset = null;
      }
      this.initialAccomodationUnit = _.cloneDeep(this.accomodationUnit);
    } else {
      if (!this.showOwnerPriceOffset) {
        this.accomodationUnit.ownerPriceOffset = null;
      }
      this.accomodationUnit = new AccomodationUnitViewModel();
      this.initialAccomodationUnit = _.cloneDeep(this.accomodationUnit);
    }
  }

  get rules() {
    return {
      required: (value: any) => !!value || this.$t("Validation.Required"),
      required0Allowed: (value: any) =>
        !!value || value === 0 || this.$t("Validation.Required"),
      zeroOrPositive: (value: any) =>
        value == null ||
        value == undefined ||
        +value >= 0 ||
        this.$t("Validation.MustBeZeroOrPositive"),
      wholeNumber: (value: any) =>
        value == null ||
        value == undefined ||
        value % 1 == 0 ||
        this.$t("Validation.MustBeWholeNumber"),
    };
  }
  

  maxLength(max: number) {
    return (v: string) =>
      !v || v.length <= max
        ? true
        : this.$t("Validation.MaxLength", { count: max });
  }

  maxValue(max: number) {
    return (v: any) =>
      v <= max ? true : this.$t("Validation.MaxValue", { max: max });
  }

  wholeNumbersOnly(value: number) {
    return (
      value == null ||
      value == undefined ||
      value % 1 == 0 ||
      this.$t("Validation.MustBeWholeNumber")
    );
  }

  isFormValid = false;
  get submitDisabled(): boolean {
    return this.isFormValid && !this.loading;
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean };
  }

  @Ref("drawer") rightDrawer?: RightDrawer;

  close() {
    this.rightDrawer?.clickOverlay();
  }

  removeWorkModelAndCategorizationInfo() {
    this.accomodationUnit.categorizationClass = null;
    this.accomodationUnit.categorizationNumber = null;
    this.accomodationUnit.categorizationDate = undefined;
    this.accomodationUnit.agencyWorkModelId = null;
  }

  async submit(ownerContractExportType?: number) {
    this.accomodationUnit.categorizationDate =
      this.accomodationUnit.categorizationDate?.toString() === ""
        ? undefined
        : this.accomodationUnit.categorizationDate;

    this.form.validate();

    if (!this.isFormValid) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("Changes are invalid or incomplete"),
        timeout: 5000,
      });

      return;
    }

    if (this.accomodationUnit.floor?.toString() === "") {
      this.accomodationUnit.floor = undefined;
    }
    if (this.accomodationUnit.shortName?.toString() === "") {
      this.accomodationUnit.shortName = this.accomodationUnit.name.substring(
        0,
        20
      );
    }

    if (
      this.accomodationUnit.ownerId == null ||
      this.accomodationUnit.ownerId == undefined
    ) {
      this.accomodationUnit.ownerPriceOffset = null;
      this.accomodationUnit.ownerDoesCleaning = false;
      this.accomodationUnit.ownerDoesCheckin = false;
      this.accomodationUnit.ownerDoesCheckout = false;
    }

    //submit
    this.saving = true;
    if (this.accomodationUnit.id && this.accomodationUnit.id !== 0) {
      await Vue.axios
        .put("/AccomodationUnits/", this.accomodationUnit)
        .then(() => {
          this.$store.dispatch("showNotification", {
            color: "success",
            message: this.$t("AccomodationUnit.SaveSuccess"),
            timeout: 5000,
          });

          if (typeof ownerContractExportType == "number") {
            this.generateOwnerContract(ownerContractExportType);
          }

          this.$emit("update:open", false);
          this.$emit("callback");
        })
        .finally(() => {
          this.saving = false;
        });
    } else {
      await Vue.axios
        .post("AccomodationUnits", this.accomodationUnit)
        .then((res) => {
          this.accomodationUnit = {
            ...this.accomodationUnit,
            id: res.data,
          };

          this.initialAccomodationUnit = _.cloneDeep(this.accomodationUnit);

          this.$store.dispatch("showNotification", {
            color: "success",
            message: this.$t("AccomodationUnit.SaveSuccess"),
            timeout: 5000,
          });

          this.$emit("update:open", false);
          this.$emit("callback");
        })
        .finally(() => {
          this.saving = false;
        });
    }

    if (this.refreshCashRegisters) {
      this.refreshCashRegisters();
    }
  }

  generateOwnerContract(ownerContractExportType: number) {
    this.loading = true;
    this.axios
      .get(`/AccomodationUnits/generateOwnerContract`, {
        params: {
          accommodationUnitId: this.accomodationUnit.id,
          exportType: ownerContractExportType,
        },
        responseType: "blob",
      })
      .then((res) => {
        const groups = /filename="?(?<filename>[^;"]+)"?;/.exec(
          res.headers["content-disposition"]
        )?.groups;
        saveFile(res.data, groups?.filename ?? "OwnerContract.docx");
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("GenerateOwnerContractSuccess"),
          timeout: 5000,
        });
      })
      .finally(() => {
        this.ownerContractExportType = null;
        this.loading = false;
      });
  }

  ownerContractExportTypes = [
    {
      value: OwnerContractExportType.Resident,
      text: "t.OwnerContractExportType.Resident",
    },
    {
      value: OwnerContractExportType.NonResident,
      text: "t.OwnerContractExportType.NonResident",
    },
    {
      value: OwnerContractExportType.LegalEntity,
      text: "t.OwnerContractExportType.LegalEntity",
    },
  ];

  evisitorFacilities: EVisitorView[] = [];
  loadPropertyEVisitoryFacilities() {
    this.axios
      .get<ListModel<EVisitorView>>(
        `properties/${this.propertyId}/eVisitorFacilities`,
        {
          params: {
            status: true,
          },
        }
      )
      .then(({ data }) => {
        this.evisitorFacilities = data.result;
      });
  }
}
